/**
 * useOutreachRow — one roster entry's RowView, read directly off the 2.2
 * Detail route (ruling 60). Backs the deep-link case: OutreachTab renders
 * ThreadView from this when the entry isn't on the table's current page.
 */
import { useQuery } from '@tanstack/react-query';
import type { OutreachRow } from '@discovr/types';
import { campaignKeys } from '../queryKeys';
import { retryOutreachQuery } from './outreachRetry';
import { fetchOutreachRow } from '../api/outreachApi';

export function useOutreachRow(campaignId: string, entryId: string | null) {
  return useQuery<OutreachRow | null>({
    queryKey: campaignKeys.outreachRow(campaignId, entryId ?? ''),
    queryFn: () => fetchOutreachRow(entryId as string),
    enabled: !!entryId,
    retry: retryOutreachQuery,
  });
}
